import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import SmartDisplayRoundedIcon from '@mui/icons-material/SmartDisplayRounded';
import {
  Alert,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import Popup2290 from '@/components/ui/2290Popup';
import BlogContentExcise from '@/components/ui/BlogContentExcise';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const PreFile2290 = () => {
  const [open, setOpen] = useState(false);
  const [isvideoPopupSteps, setvideoPopupSteps] = useState(false);
  const openPopupSteps = () => {
    setvideoPopupSteps(true);
  };

  return (
    <AppLayout
      meta={
        <Meta
          title="Pre-File IRS Form 2290 Online for the 2026 Tax Year "
          description="Pre-file your IRS Form 2290 for 2026 with TaxZerone. File early and get your stamped Schedule 1 by July 1, 2026. Start your hassle-free HVUT filing today."
          keywords=""
          canonical="excise-tax/pre-file-form-2290/"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="3830"
          ogShareImg="assets/images/excise-share-img.png"
        />
      }
    >
      <ExciseSubMenu />
      <Popup2290 />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <VideoPopup
        isvideoPopup={isvideoPopupSteps}
        setvideoPopup={setvideoPopupSteps}
        src="https://www.youtube.com/embed/GBPEXHFlyMA?autoplay=1&rel=0"
      />
      <Box sx={{ backgroundColor: '#c5ebfd', pt: 4 }}>
        <Container
          sx={{
            position: 'relative',
            pt: 0,
            mb: 0,
            // maxWidth: { xs: '100%', sm: 820, md: 820, lg: 940 },
          }}
          maxWidth="lg"
        >
          <Box
            sx={{
              background: '#d95623',
              p: 1,
              px: 2,
              color: '#fff',
              '&.ribbon:before': {
                left: { xs: 8, sm: 16 },
                background:
                  'url(/assets/images/ribbon-bg-new.webp) repeat 100%',
                transform: 'rotate(-360deg)',
              },
              '&.ribbon:after': {
                right: { xs: 8, sm: 16 },
                background:
                  'url(/assets/images/ribbon-bg-new.webp) repeat 100%',
                transform: 'rotate(-180deg)',
              },
            }}
            className="ribbon"
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems="center"
              spacing={{ xs: 1, sm: 2 }}
              justifyContent="center"
            >
              <Typography
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 16, sm: 18, md: 18, lg: '1.13rem' },
                  color: '#eee',
                }}
              >
                <strong>📢 Form 2290 (2026–2027) </strong> E-Filing{' '}
                <b style={{ color: '#fff', fontWeight: 600 }}>Is Now Open </b>—
                File Your
                <b style={{ color: '#fff' }}> HVUT</b> Return Today
              </Typography>
              {/* <Box>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                    mb: { xs: 1, sm: 1 },
                    lineHeight: 1.3,
                    color: '#ececec',
                  }}
                >
                  Time left to file before the deadline{' '}
                  <Hidden smUp>
                    <br />
                  </Hidden>
                  (
                  <span style={{ fontWeight: 600, color: '#fff' }}>
                    Sept 02, 2025
                  </span>
                  ):
                </Typography> */}
              {/* <Countdown date={lastDayTaxSeason} renderer={renderer} /> */}
              {/* </Box> */}
              <Box sx={{ textAlign: 'right' }}>
                <Button
                  variant="contained"
                  size="large"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                  sx={{
                    backgroundColor: '#fff',
                    '&:hover, &:focus': {
                      backgroundColor: '#333',
                      color: '#fff',
                      boxShadow: 'none',
                    },
                    px: 2,
                    color: '#333',
                    mt: { xs: 0, md: 0 },
                    display: { xs: 'inline-block', sm: 'inline-block' },
                    mx: { xs: 'auto', sm: 1 },
                    borderRadius: 3,
                    boxShadow: 'none',
                    fontSize: 18,
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Pre-File Now
                </Button>
              </Box>
            </Stack>
          </Box>
        </Container>
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
            sx={{ px: { xs: 2, md: 0 } }}
          >
            <Box
              sx={{
                textAlign: { xs: 'center', md: 'left' },
                alignItems: 'center',
                display: 'flex',
                width: '100%',
                maxWidth: { xs: 'inherit', lg: 770 },
                minWidth: { xs: 'inherit', md: 530 },
                pl: { xs: 0, md: 6, lg: 8, xl: 12 },
                justifyContent: 'center',
              }}
            >
              <Box
                component="div"
                sx={{
                  mt: { xs: 2, sm: 4, md: 5 },
                  mb: { xs: 2, sm: 4, md: 5 },
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                    fontWeight: 600,
                    color: '#374151',
                    mb: 3,
                  }}
                >
                  Pre-File{' '}
                  <span className="highlight-container">
                    <span className="highlight">IRS Form 2290</span>
                  </span>
                  {'  '}
                  for the 2026–27 Tax Year
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                  }}
                >
                  Pre-file your{' '}
                  <span style={{ fontWeight: 600 }}> HVUT Form 2290</span> with
                  TaxZerone now to get your Schedule 1 early and stay ahead of
                  your highway use tax deadlines.
                </Typography>
                <Stack
                  direction={{ xs: 'column-reverse', sm: 'row' }}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                  sx={{ mt: { xs: 2, sm: 4 } }}
                >
                  <Box
                    sx={{ textAlign: 'center', mr: { xs: 0, sm: 4, md: 3 } }}
                  >
                    <Button
                      variant="contained"
                      className="btn-primary medium"
                      sx={{
                        fontSize: {
                          xs: '16px !important',
                          sm: '18px !important',
                          lg: '24px !important',
                        },
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                    >
                      Pre-File Form 2290 Now
                    </Button>
                    <Typography
                      variant="body2"
                      sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                    >
                      Easy filing in minutes
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '16px !important', sm: '22px !important' },
                      mr: { xs: 0, sm: 4, md: 3 },
                    }}
                  >
                    <Tooltip title="How to Pre-File Form 2290 online?" arrow>
                      <IconButton sx={{}} onClick={openPopupSteps}>
                        <SmartDisplayRoundedIcon
                          sx={{ color: '#f00', fontSize: 48 }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent={{
                      xs: 'center',
                      md: 'flex-start',
                    }}
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        mb: { xs: '0 !important', md: '22px !important' },
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/irs-authorized.webp" />
                        <source srcSet="/assets/images/irs-authorized.png" />
                        <Box
                          component="img"
                          src="/assets/images/irs-authorized.png"
                          loading="lazy"
                          alt="IRS-authorized e-file provider"
                          width={70}
                          height={69}
                          sx={{
                            width: { xs: 50, md: 70 },
                            height: { xs: 49, md: 69 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box
                      sx={{
                        mb: { xs: '0px !important', md: '22px !important' },
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/tzo-soc2.webp" />
                        <source srcSet="/assets/images/tzo-soc2.png" />
                        <Box
                          component="img"
                          src="/assets/images/tzo-soc2.png"
                          loading="lazy"
                          alt="TZO SOC2 Compliant"
                          width={90}
                          height={89}
                          sx={{
                            width: { xs: 70, md: 90 },
                            height: { xs: 69, md: 89 },
                          }}
                        />
                      </picture>
                    </Box>
                  </Stack>
                </Stack>
              </Box>
            </Box>
            <Hidden mdDown>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  width: '100%',
                }}
                className="prefile-bg"
              >
                <picture style={{ marginBottom: -7 }}>
                  <source
                    srcSet="/assets/images/pre-file-img.webp"
                    className="img-responsive-banner"
                    width={880}
                    height={725}
                  />
                  <source
                    srcSet="/assets/images/pre-file-img.png"
                    className="img-responsive-banner"
                    width={880}
                    height={725}
                  />
                  <img
                    src="/assets/images/pre-file-img.png"
                    alt="Pre-File IRS Form 2290 for the 2026–27 Tax Year"
                    className="img-responsive-banner"
                    width={880}
                    height={725}
                  />
                </picture>
              </Box>
            </Hidden>
            <Hidden mdUp smDown>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'flex-end',
                  width: '100%',
                  backgroundPosition: 'center center !important',
                  mt: '0 !important',
                }}
                className="prefile-bg"
              >
                <picture style={{ marginBottom: -7 }}>
                  <source
                    srcSet="/assets/images/pre-file-img-sm.webp"
                    className="img-responsive-banner"
                    width={440}
                    height={365}
                  />
                  <source
                    srcSet="/assets/images/pre-file-img-sm.png"
                    className="img-responsive-banner"
                    width={440}
                    height={365}
                  />
                  <img
                    src="/assets/images/pre-file-img-sm.png"
                    alt="Pre-File IRS Form 2290 for the 2026–27 Tax Year"
                    className="img-responsive-banner"
                    width={440}
                    height={365}
                  />
                </picture>
              </Box>
            </Hidden>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#333',
          overflow: 'hidden',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          py: 2,

          zIndex: 99,
          backgroundSize: { xs: '25% auto', sm: '15% auto', md: '10% auto' },
        }}
        spacing={0}
        m={0}
        className="wave-bg"
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 14, sm: 15, md: 18, lg: '1.475rem' },
                  color: '#fff',
                }}
              >
                <strong style={{ color: '#ffe400' }}>
                  Attention Truckers!
                </strong>{' '}
                Your <b>2025 Schedule 1</b> is expiring soon.{' '}
                <Hidden mdDown>
                  <br />
                </Hidden>
                E-File <b>IRS Form 2290</b> Online Now for Tax Year 2026
              </Typography>
            </Box>
            <Box>
              <Button
                variant="contained"
                size="large"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                sx={{
                  backgroundColor: '#1da94a',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Form 2290
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' }, mb: { md: 3 } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is Pre-File Form 2290?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Pre-filing Form 2290 allows you to report and pay the Heavy
                  Vehicle Use Tax for the upcoming tax year before it begins.
                  The pre-filing begins on{' '}
                  <span style={{ fontWeight: 600 }}> May 1, 2026</span>, and
                  ends on <span style={{ fontWeight: 600 }}>June 30, 2026</span>{' '}
                  for the 2026-2027 tax period.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  This tax is required annually for vehicles weighing{' '}
                  <b>55,000 lbs or more</b>. Pre-filing ensures compliance,
                  avoids late penalties, and simplifies your tax obligations by
                  taking care of it early.
                </Typography>
                <Alert severity="warning" icon={false}>
                  <strong>Note:</strong> Once the IRS begins accepting returns
                  for the new filing year on or after <b>July 1, 2026</b>, and
                  starts issuing <b>IRS Watermarked Schedule 1</b>, your
                  submission for the 2026–2027 tax year will be processed
                  accordingly.
                </Alert>

                <Box
                  sx={{
                    width: 'auto',
                    textAlign: 'left',
                    alignItems: 'center',
                    display: 'inline-block',
                    mt: { xs: 2, sm: 2 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    Start Pre-filing Now
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <Box
                  component="iframe"
                  title="What is Form 2290: A Comprehensive Guide"
                  src="https://www.youtube.com/embed/GBPEXHFlyMA?&rel=0"
                  sx={{
                    width: { xs: '100%', sm: 500 },
                    height: { xs: '100%', sm: 281 },
                    border: '10px solid #333 !important',
                    borderRadius: 5,
                  }}
                  allowFullScreen={true}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' }, mb: { md: 3 } }}
          >
            {' '}
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/avoid-mistake-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/avoid-mistake-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/avoid-mistake-img.png"
                    alt="Who can Pre-file HVUT Form 2290?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={580}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Who can Pre-file HVUT Form 2290?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 1,
                  }}
                >
                  Truckers who register a heavy highway motor vehicle in their
                  name with a taxable gross weight of 55,000 pounds or more must{' '}
                  <Link
                    href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    file Form 2290
                  </Link>{' '}
                  and pay the tax.
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 600,
                    color: '#333333',
                    mb: 0,
                  }}
                >
                  Example:
                </Typography>
                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  <li>Vehicle owners (individuals or businesses)</li>
                  <li>
                    Owner-operators (truck drivers who own their vehicles){' '}
                  </li>
                  <li>Trucking companies or fleet owners</li>
                  <li>
                    Leasing companies (if the vehicle is registered in their
                    name){' '}
                  </li>
                  <li>
                    Any entity required to register a heavy vehicle in their
                    name{' '}
                  </li>
                </Box>

                {/* <Box
                  sx={{
                    width: 'auto',
                    textAlign: 'left',
                    alignItems: 'center',
                    display: 'inline-block',
                    mt: { xs: 2, sm: 2 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    Start Pre-filing Now
                  </Button>
                </Box> */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={5}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/pre-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/pre-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/pre-file-icon.png"
                      alt="Pre-File Form 2290"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Pre-File Form 2290
                </Typography>
                <Typography variant="body1">
                  Start your 2290 tax filing process early with TaxZerone,
                  minimizing the risk of errors.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                  >
                    Pre-File Now
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vin-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vin-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vin-icon.png"
                      alt="Free VIN Correction"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FREE VIN Correction
                </Typography>
                <Typography variant="body1">
                  Get FREE{' '}
                  <Link
                    href="/excise-tax/efile-irs-form-2290-vin-correction-online/"
                    sx={{ color: '#0202ff' }}
                  >
                    VIN Correction
                  </Link>{' '}
                  on your <br />
                  Pre-filed Form 2290. Correct VIN errors quickly and easily at
                  any time.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                  >
                    VIN Correct Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="FREE resubmissions"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FREE resubmissions
                </Typography>
                <Typography variant="body1">
                  If the IRS rejects your Form 2290 for any reason, you can fix
                  and resend it without extra charges.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
                  >
                    E-file Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid> */}

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Form 2290 Filing Timeline for 2026 Tax Year
              </Typography>
            </Grid>
            <Grid size={{ md: 3.5, sm: 4, xs: 12 }} sx={{}}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  backgroundColor: '#f0f2f9',
                  py: 5,
                  minHeight: '100%',
                  borderRadius: 3,
                  mx: 0,
                  borderTop: '5px solid #0fc759',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 400, textTransform: 'uppercase', mb: 1 }}
                >
                  Pre-Filing Begins
                </Typography>{' '}
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 36, sm: 24, xs: 20 },
                    mb: 1,
                  }}
                >
                  May 1
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  2026
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ md: 1.5, sm: 2, xs: 12 }}
              sx={{ textAlign: 'center' }}
            >
              <Box>
                <ArrowForwardIcon sx={{ fontSize: 36 }} />
              </Box>
            </Grid>
            <Grid size={{ md: 3.5, sm: 4, xs: 12 }} sx={{}}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  backgroundColor: '#f0f2f9',
                  py: 5,
                  minHeight: '100%',
                  borderRadius: 3,
                  mx: 0,
                  borderTop: '5px solid #ff0f13',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 400, textTransform: 'uppercase', mb: 1 }}
                >
                  Pre-Filing Ends
                </Typography>{' '}
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 36, sm: 24, xs: 20 },
                    mb: 1,
                  }}
                >
                  June 30
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  2026
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3.5, sm: 4, xs: 12 }} sx={{}}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  backgroundColor: '#f0f2f9',
                  py: 5,
                  minHeight: '100%',
                  borderRadius: 3,
                  mx: 0,
                  borderTop: '5px solid #0f2fff',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 400, textTransform: 'uppercase', mb: 1 }}
                >
                  Final Deadline
                </Typography>{' '}
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 36, sm: 24, xs: 20 },
                    mb: 1,
                  }}
                >
                  August 31
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  2026
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Alert
                severity="warning"
                icon={false}
                sx={{
                  mt: 1,
                  mb: 0,
                  maxWidth: 800,
                  mx: 'auto',
                  borderLeft: '3px solid rgb(102, 60, 0)',
                }}
              >
                <b>Note :</b> File early to receive your stamped Schedule 1 as
                soon as the IRS begins processing on{' '}
                <span style={{ fontWeight: 600 }}> July 1,2026</span>.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to Pre-File Form 2290 for the tax year 2026?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Use TaxZerone to pre-file your Heavy Vehicle Use Tax return{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>{' '}
                for the 2026–2027 tax year, making tax compliance simple.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            pb={{ xs: 0, md: 3 }}
            className="MuiGrid-root-width"
            alignItems="stretch"
          >
            <Grid
              size={{ xs: 12, sm: 2 }}
              sx={{ position: 'relative', pt: '0px !important' }}
            />
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{ position: 'relative', pt: '0px !important' }}
            >
              <span className="step-arrow">
                <img
                  src="/assets/images/arrow-right.png"
                  alt="arrow right"
                  width={10}
                  height={16}
                />
              </span>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 4 }}
              sx={{
                position: 'relative',
                pt: '0px !important',
              }}
            >
              <span className="step-arrow">
                <img
                  src="/assets/images/arrow-right.png"
                  alt="arrow right"
                  width={10}
                  height={16}
                />
              </span>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 4 }}
              className="responsive dotted-line"
              sx={{ position: 'relative' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 0,
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Select the Pre-File"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box
                  component="span"
                  sx={{
                    background: '#213e99',
                    px: 1,
                    py: 0.5,
                    borderRadius: 2,
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 600,
                    display: 'inline-block',
                    mb: 1,
                    minWidth: 75,
                  }}
                >
                  Step 1
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Select the Pre-File
                </Typography>
                <Typography variant="body1">
                  choose the pre-file option for the 2026 tax year
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 4 }}
              className="responsive dotted-line"
              sx={{ position: 'relative' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 0,
                  minHeight: '100%',
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/review-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/review-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/review-icon.png"
                      alt="Enter Form Details"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box
                  component="span"
                  sx={{
                    background: '#1f7272',
                    px: 1,
                    py: 0.5,
                    borderRadius: 2,
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 600,
                    display: 'inline-block',
                    mb: 1,
                    minWidth: 75,
                  }}
                >
                  Step 2
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Enter Form Details
                </Typography>
                <Typography variant="body1">
                  Enter your business details, such as name, EIN, VIN, taxable
                  gross weight, & first used month (FUM)
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 0,
                  minHeight: '100%',
                  borderRadius: 10,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="Transmit your returns"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box
                  component="span"
                  sx={{
                    background: '#1da94a',
                    px: 1,
                    py: 0.5,
                    borderRadius: 2,
                    color: '#fff',
                    fontSize: 14,
                    fontWeight: 600,
                    display: 'inline-block',
                    mb: 1,
                    minWidth: 75,
                  }}
                >
                  Step 3
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Transmit your returns
                </Typography>
                <Typography variant="body1">
                  Submit your tax return early to the IRS to ensure timely
                  processing
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={0}
            pb={2}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 9 }}
              textAlign="center"
              mt={{ xs: 0, md: 0 }}
              mb={{ xs: 0, sm: 0, md: 0 }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  lineHeight: 1.5,
                }}
              >
                Simply upload your previous year's Schedule 1, and our advanced
                system will automatically import your vehicle details and filing
                information—saving you time and reducing manual data entry.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  mt: 4,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': {
                    background: '#213e99 !important',
                    transform: 'scale(1.1)',
                  },
                }}
                className="btn-secondary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
              >
                Pre-File Now
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Common Mistakes to Avoid When Filing HVUT Early:
              </Typography>
              <Typography variant="body1">
                Here are the most common mistakes truckers make when pre-filing
                HVUT:
              </Typography>
              <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                <li>Entering the wrong VIN</li>
                <li>Selecting the incorrect tax year</li>
                <li>Misreporting taxable gross weight </li>
                <li>Filing for non-taxable vehicles </li>
                <li>Incorrect First Used Month(FUM) </li>
                <li>Incorrect EIN or not meeting EIN activation rules </li>
                <li>Duplicate filings </li>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/pre-file-common-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/pre-file-common-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/pre-file-common-img.png"
                    alt="Common Mistakes on Prefiling HVUT"
                    className="img-responsive"
                    loading="lazy"
                    width={600}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Pre-File Form 2290 with TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Truckers enjoy peace of mind with TaxZerone&apos;s secure
                pre-filing of Form 2290 for the 2026 tax year.
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy & Fast Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy & Fast Filing
                </Typography>
                <Typography variant="body1">
                  Pre-file in minutes and get your Schedule 1 as soon as the IRS
                  processing begins
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Supports bulk upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Supports bulk upload
                </Typography>
                <Typography variant="body1">
                  TaxZerone&apos;s bulk upload feature allows you to pre-file
                  HVUT form for multiple vehicles at once by uploading a file
                  with vehicle details.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/magic-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/magic-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/magic-icon.png"
                      alt="Automatic Form Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Automatic Form Filing
                </Typography>
                <Typography variant="body1">
                  Upload your previous year Schedule 1 and let TaxZerone
                  auto-populate your return.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/mobile-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/mobile-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/mobile-icon.png"
                      alt="Convenient Online Process"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Convenient Online Process
                </Typography>
                <Typography variant="body1">
                  File from anywhere, anytime, with TaxZerone&apos;s
                  user-friendly online platform.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fleet-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fleet-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fleet-icon.png"
                      alt="Support All Trucking Business"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Support All Trucking Business
                </Typography>
                <Typography variant="body1">
                  Whether it&apos;s an owner-operator or a fleet with multiple
                  trucks, our intuitive UI provides a specific flow to assist
                  them efficiently.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Automatic Reminders"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Automatic Reminders
                </Typography>
                <Typography variant="body1">
                  Receive timely reminders from TaxZerone to ensure you never
                  miss a filing deadline.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ justifyContent: 'center', my: 3 }}>
          <Grid
            container
            spacing={2}
            m={0}
            mt={4}
            mb={6}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Benefits of Pre-Filing Form 2290 (2026–2027)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Pre-file your Heavy Vehicle Use Tax return and keep your fleet
                  moving without interruption.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  border: 'none',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Vehicle Registration on Time "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Vehicle Registration on Time
                </Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>
                  Many states require a valid Schedule 1 for registration
                  renewal. Pre-file so you're never blocked at the DMV.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                  border: 'none',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Reduce Filing Errors"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Reduce Filing Errors
                </Typography>
                <Typography variant="body1">
                  You will get extra time to review and verify all vehicle
                  details before your return is transmitted to the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                  border: 'none',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Save Time for Corrections"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Save Time for Corrections
                </Typography>
                <Typography variant="body1">
                  If an amendment is needed, early filing gives you a buffer to
                  fix it before the deadline without penalties.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  border: 'none',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Avoid the Last-Minute Filing Rush"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Avoid the Last-Minute <br /> Filing Rush
                </Typography>
                <Typography variant="body1">
                  Pre-file your HVUT form before the tax season begins and avoid
                  the stress of last-minute filing.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                  border: 'none',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Reduce Penalty Risk"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Reduce Penalty Risk
                </Typography>
                <Typography variant="body1" sx={{ mt: 5 }}>
                  Late HVUT filings attract IRS penalties and interest.
                  Pre-filing helps you avoid costly mistakes.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
          mb: -0.8,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              textAlign="right"
              sx={{ pt: '0 !important' }}
            >
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/excise-app-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/excise-app-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/excise-app-img.png"
                    alt="Install the TaxZerone 2290 App now!"
                    className="img-responsive"
                    loading="lazy"
                    width={512}
                    height={600}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Install the TaxZerone 2290 App now!
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  You can now pre-file HVUT form using your iPhone, iPad, or
                  Android devices.
                </Typography>
                <Typography component="div" variant="body1" sx={{ mb: 3 }}>
                  <ul
                    style={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                    }}
                  >
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      User-Friendly Interface
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Quick Filing
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Secure Transactions
                    </li>
                  </ul>
                </Typography>

                <Typography
                  variant="body1"
                  color="secondary"
                  sx={{ fontWeight: 600 }}
                >
                  Get our app now and enjoy the lightning-fast performance
                </Typography>
                <Box
                  sx={{
                    my: 1,
                    mb: 0,
                    '& img': {
                      width: { xs: 120, sm: 180 },
                      height: { xs: 37, sm: 55 },
                    },
                  }}
                >
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.taxzerone.excisetaxes"
                    target="_blank"
                    sx={{
                      mr: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Available on the Google Play" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/play-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/play-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/play-store-img.png"
                          alt="Available on the Google Play"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <Link
                    href="https://apps.apple.com/us/app/e-file-form-2290-pay-hvut/id6450998674"
                    target="_blank"
                    sx={{
                      ml: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Download on the App Store" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/app-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/app-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/app-store-img.png"
                          alt="Download on the App Store"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                </Box>
                {/* <Typography
                  variant="body2"
                  sx={{ mt: 0, mb: { xs: 2, md: 2 } }}
                >
                  Haul in the high-speed express lane for HVUT filing!
                </Typography> */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { md: 8, sm: 4, xs: 2 },
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Helpful Resources for Every Truckers
              </Typography>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,
                    backgroundColor: '#f0f2f9',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Form 2290 Instructions
                  </Typography>
                  <Typography variant="body1">
                    Follow our step-by-step guidance for completing your HVUT
                    return accurately.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-due-dates/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    backgroundColor: '#f0f2f9',
                    borderRadius: 4,
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    HVUT Due Dates
                  </Typography>
                  <Typography variant="body1">
                    Stay informed about key filing deadlines and important tax
                    dates.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-amendments/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    backgroundColor: '#f0f2f9',
                    borderRadius: 4,
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    HVUT Amendments
                  </Typography>
                  <Typography variant="body1">
                    Find out when updates are required and how to make
                    corrections.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-8849-schedule-6-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    backgroundColor: '#f0f2f9',
                    borderRadius: 4,
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Form 8849
                  </Typography>
                  <Typography variant="body1">
                    Discover eligibility requirements and the refund claim
                    process.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-schedule-1/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,
                    backgroundColor: '#f0f2f9',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    IRS Schedule 1
                  </Typography>
                  <Typography variant="body1">
                    Explore everything you need to know about obtaining and
                    using Schedule 1.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/hvut-form-2290-penalties/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,
                    backgroundColor: '#f0f2f9',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Penalties & Compliance
                  </Typography>
                  <Typography variant="body1">
                    Understand common penalties, interest charges, and ways to
                    avoid them.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Start Your Pre-File Form 2290 with TaxZerone
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Best E-filing platform for fleet drivers & truck owners to pre-file
          road tax online. <br />
          Simplify tax compliance with our user-friendly service.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              display: { xs: 'inline-flex', sm: 'inline-flex' },
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=prefile2290`}
          >
            Pre-File&nbsp;<b>Form 2290</b>
          </Button>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 32, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 3 },
                }}
              >
                On the Road to Success: Truckers Share Their TaxZerone
                Experience
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Read the satisfied truckers&apos; experiences and see why
                TaxZerone is the trusted choice for stress-free Pre-filing
              </Typography>
              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
              >
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I did my tax filing early this year, and it felt good
                        not worrying about deadlines. I’ll definitely do this
                        again.{' '}
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>

                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>

                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        textAlign: 'right',
                      }}
                    >
                      -Sarah Mitchell
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        The whole process of pre-filing Form 2290 was
                        straightforward. No confusion, no delays. Highly
                        Recommended!
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        textAlign: 'right',
                      }}
                    >
                      -Ryan Bennett
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I didn’t even know 2290 prefiling was an option before.
                        Now that I’ve used it, I’ll probably stick with it every
                        year.{' '}
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Chloe Adams
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I had time to go through everything properly instead of
                        rushing my HVUT filing. That alone made a big difference
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Lauren Hayes
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          //  backgroundColor: '#1da94a',
          pt: { lg: 0, md: 0, sm: 0, xs: 2 },
          pb: { lg: 4, md: 4, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={2}
        mt={0}
        //  className="curve-bg"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              my={{ xs: 2, sm: 5 }}
              mb={3}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                FAQs on Form 2290
              </Typography>
              <Box
                component="div"
                sx={{ mb: 5 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    1. Can I pre-file form 2290 tax returns to the IRS using
                    TaxZerone?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="div" itemProp="text">
                      <b>Yes</b>, you can pre-file Form 2290 tax returns to the
                      IRS using TaxZerone. It allows you to submit your
                      information early, streamlining the process for when the
                      official filing season opens.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    2. How to pre-file the 2290 form online?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="div" itemProp="text">
                      To pre-file your{' '}
                      <Link
                        href="/resources/excise-tax/form-2290-instructions/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        Form 2290 online
                      </Link>
                      , simply create a Free account on the TaxZerone website,
                      enter your vehicle information, review and pay the tax
                      due, and then submit your pre-filing to the IRS.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    3. Why should I pre-file Form 2290 for the Heavy Vehicle Use
                    Tax (HVUT)?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="div" itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          Pre-file today and receive your stamped{' '}
                          <Link
                            href="/resources/excise-tax/form-2290-schedule-1/"
                            sx={{ color: '#0202ff' }}
                          >
                            Schedule 1
                          </Link>{' '}
                          as soon as the IRS begins processing.{' '}
                        </li>
                        <li>
                          Pre-filing gives you time to make changes to your
                          2290, if required.{' '}
                        </li>
                        <li>
                          Secure your Schedule 1 early and stay clear of
                          penalties.{' '}
                        </li>
                        <li>
                          Avoid last-minute filing stress and IRS system
                          delays.{' '}
                        </li>
                        <li>Plan your HVUT payment ahead of the deadline. </li>
                        <li>Ensure IRS compliance with peace of mind. </li>
                      </Box>
                    </Typography>
                  </Box>
                </Box>
                <Box
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    4. What information is required to pre-file Form 2290 for
                    HVUT?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="div" itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>Business Name and EIN </li>
                        <li>Tax Period and First Used Month </li>
                        <li>Vehicle Identification Number (VIN) </li>
                        <li>Taxable Gross Weight of the Vehicle </li>
                        <li>IRS Payment details </li>
                      </Box>
                    </Typography>
                  </Box>
                </Box>
                <Box
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    5. Can Owner-Operators Pre-file Form 2290 for HVUT?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="div" itemProp="text">
                      <span style={{ fontWeight: 600 }}> Yes</span>,{' '}
                      <Link
                        href="https://www.owneroperator2290.com/"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        owner-operators
                      </Link>{' '}
                      can pre-file Form 2290 for the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Heavy Vehicle Use Tax
                      </span>{' '}
                      (HVUT). Pre-filing allows owner-operators to submit their
                      return before the IRS officially begins processing,
                      helping them receive their stamped Schedule 1 faster,
                      avoid late penalties, correct any errors in advance, and
                      stay compliant with IRS regulations. It’s a smart way to
                      ensure timely filing and maintain valid vehicle
                      registration.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    6. When will i receive my Form 2290 Schedule 1?
                  </Typography>

                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Typography component="div" itemProp="text">
                      After you pre-file Form 2290, your return will be securely
                      stored and transmitted to the IRS when the filing season
                      opens in July. Once the IRS accepts your return, stamped
                      Schedule 1 will be emailed to you, typically within
                      minutes of acceptance.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ textAlign: 'center', mt: 3 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  sx={{
                    borderWidth: 2,
                    borderRadius: 3,
                    textTransform: 'none',
                    '&:hover, &:focus, &:active': { borderWidth: 2 },
                  }}
                  href="/faqs/form-2290/"
                >
                  More FAQs
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ mt: 2, mb: { xs: 2, sm: 0 } }} />
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ mb: { xs: 3, sm: 5, md: 8 } }}>
        <Grid container spacing={2} m={0} pb={0} className="MuiGrid-root-width">
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 0, sm: 3 },
                textAlign: 'center',
                lineHeight: 1.5,
                mt: 0,
              }}
            >
              Recent Blogs
            </Typography>
          </Grid>

          <BlogContentExcise />
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default PreFile2290;
